{
  "version": "1.0.0",
  "voices": [
    {
      "id": "Aoede",
      "name": "Orange",
      "description": "Feminine, bright, medium pitch",
      "isDefault": true
    },
    {
      "id": "Orus",
      "name": "Blue",
      "description": "Masculine, bright, medium pitch"
    },
    {
      "id": "Gacrux",
      "name": "Green",
      "description": "Feminine, smooth, low pitch",
      "isDefault": true
    },
    {
      "id": "Algieba",
      "name": "Purple",
      "description": "Masculine, smooth, low pitch"
    }
  ]
}
